export default __webpack_public_path__ + "static/media/alex3.811b3b82.jpg";